export const createGuestFormStore = async () => {
    const m = await import(
        /* webpackChunkName: 'guest_form_store.js' */
        './GuestFormStore'
    );

    return new m.GuestFormStore();
};
